/** TODO: This code was moved from Dashboard to allow tooltip location logic to be used in iron/common.
 * Consolidate tooltip location logic as part of Dashboard chart logic. */

export const TOOLTIP_THROTTLE_TIME = 50;

export interface ChartTooltipTargets {
  /* The class that triggers tooltip hover */
  mainClass: string;
  /* The enclosing container of the segments */
  containerClass: string;
}

export type TooltipPosition =
  | {
      bottom: string;
      right: string;
    }
  | {
      top: string;
      right: string;
    }
  | {
      bottom: string;
      left: string;
    }
  | {
      top: string;
      left: string;
    };
/**
 * This function uses a mainClass and containerClass to best approximate where to align the tooltip.
 * Based on the current quadrant of the containerClass your mouse is in, it will align to top, bottom, left, or right
 */
export function determineTooltipPosition({
  ev,
  chartClasses,
}: {
  ev: any;
  chartClasses: ChartTooltipTargets;
}): TooltipPosition {
  const cursorSpace = 10;
  const composedPath = ev.composedPath();

  const barClientRect = composedPath
    .find((element) => element.classList.contains(chartClasses.mainClass))
    .getBoundingClientRect();

  const containerClientRect = composedPath
    .find((element) => element.classList.contains(chartClasses.containerClass))
    .getBoundingClientRect();

  const leftPos = ev.clientX - barClientRect.left + cursorSpace;
  const rightPos = barClientRect.right - ev.clientX + cursorSpace;
  const yMid = barClientRect.height / 2;
  const topPos = yMid / 3; // using a ratio here to provide padding to bars with variable height
  const bottomPos = barClientRect.height - topPos - 2;

  const shouldRepositionX = leftPos + barClientRect.left - containerClientRect.left > containerClientRect.width / 2;
  const shouldRepositionY = barClientRect.y > containerClientRect.y + containerClientRect.height / 2;

  return {
    ...(shouldRepositionX ? {right: `${rightPos}px`} : {left: `${leftPos}px`}),
    ...(shouldRepositionY ? {bottom: `${bottomPos}px`} : {top: `${topPos}px`}),
  };
}
